<div class="contents-area">
  <div class="element-column">
    <div class="block-row">
      <div class="column-list">
        <label class="list-input-title width-A">Ｐコード</label>
        <div class="list-input-content">
          <input type="text" id="txti_PCode" [(ngModel)]="model.masterInput.pCode" [style.width.rem]="7" readonly/>
        </div>
      </div>
      <div class="column-list">
        <label class="list-input-title width-A">アイテムコード</label>
        <div class="list-input-content">
          <input type="text" id="txti_ItemCode" [(ngModel)]="model.masterInput.itemCode" [style.width.rem]="6" readonly/>
        </div>
      </div>
      <div class="column-list">
        <label class="list-input-title width-A">JANコード</label>
        <div class="list-input-content">
          <input type="text" id="txti_Jancode" [(ngModel)]="model.masterInput.janCode" plessInputTextSub
            [restrict]="'[0-9]'" [maxlength]="13" [tabindex]="0" [style.width.rem]="10" [disabled]="isBeforeProposing() || hontouroku"
            (blur)="eventJanCode_FOCUS_OUTHandler()"/>
        </div>
      </div>
    </div>
    <div class="block-row">
      <div class="column-list">
        <label class="list-input-title width-A">商品名</label>
        <div class="list-input-content">
          <app-text-input id="txti_goodsName" [subid]="'txti_GoodsName'" [(ngModel)]="model.masterInput.goodsName"
            [fullOnly]="true" [maxChars]="30" [restrict]="'[ -￮]'" [displayCountField]="false" [tabindex]="0"
            width="32rem" [disabled]="isRegistOrBeforeProposing() || hontouroku">
          </app-text-input>
        </div>
      </div>
      <div class="column-list">
        <label class="list-input-title width-A">規格名</label>
        <div class="list-input-content">
          <app-text-input id="txti_standardName" [subid]="'txti_StandardName'"
            [(ngModel)]="model.masterInput.standardName" [fullOnly]="true" [maxChars]="15" [restrict]="'[ -￮]'"
            [displayCountField]="false" [tabindex]="0" width="16rem" [disabled]="isRegistOrBeforeProposing() || hontouroku">
          </app-text-input>
        </div>
      </div>
    </div>

    <div class="column-list">
      <label class="list-input-title width-A">掲載媒体</label>
      <div class="list-input-content">
        <app-medium-type-combo-box id="cmb_MediumType" [subid]="'cmb_MediumType'"
          [(ngModel)]="model.masterInput.mediumType" [tabindex]="0" [style.width.px]="200"
          [disabled]="hontouroku">
        </app-medium-type-combo-box>
      </div>
    </div>

    <div class="block-row">
      <div class="column-list">
        <label class="list-input-title width-A">部門</label>
        <div class="list-input-content">
          <app-class-code-combo-box #cmb_ClassCode id="cmb_ClassCode" [subid]="'cmb_ClassCode'"
            [(ngModel)]="model.masterInput.classCode" [tabindex]="-1" [width]="250" [disabled]="true">
          </app-class-code-combo-box>
        </div>
      </div>
      <div class="column-list">
        <label class="list-input-title width-A">大分類</label>
        <div class="list-input-content">
          <app-large-class-code-combo-box #cmb_LargeClassCode id="cmb_LargeClassCode" [subid]="'cmb_LargeClassCode'"
            [blank]=" true" [classCodeComboBoxFlg]="true" [classCode]="cmb_ClassCode.selectedClassCode" [tabindex]="0"
            [width]="250" [initAutoLoad]="true" [disabled]="hontouroku">
          </app-large-class-code-combo-box>
        </div>
      </div>
      <div class="column-list">
        <label class="list-input-title width-A">中分類</label>
        <div class="list-input-content">
          <app-middle-class-code-combo-box #cmb_MiddleClassCode id="cmb_MiddleClassCode" [subid]="'cmb_MiddleClassCode'"
            [classCodeComboBoxFlg]=" true" [largeClassCodeComboBoxFlg]="true" [blank]="true"
            [classCode]="cmb_ClassCode.selectedClassCode" [largeClassCode]="cmb_LargeClassCode.selectedLargeClassCode"
            [tabindex]="0" [width]="250" [disabled]="hontouroku">
          </app-middle-class-code-combo-box>
        </div>
      </div>
      <div class="column-list">
        <label class="list-input-title width-A">小分類</label>
        <div class="list-input-content">
          <app-small-class-code-combo-box #cmb_SmallClassCode id="cmb_SmallClassCode" [subid]="'cmb_SmallClassCode'"
            [blank]="true" [classCodeComboBoxFlg]="true" [largeClassCodeComboBoxFlg]="true"
            [classCode]="cmb_ClassCode.selectedClassCode" [largeClassCode]="cmb_LargeClassCode.selectedLargeClassCode"
            [middleClassCode]="cmb_MiddleClassCode.selectedMiddleClassCode" [tabindex]="0" [width]="250"
            [disabled]="hontouroku">
          </app-small-class-code-combo-box>
        </div>
      </div>
    </div>
    <div class="block-row">
      <div class="column-list">
        <label class="list-input-title width-A">発注単位区分</label>
        <div class="list-input-content">
          <app-code-combo-box id="cmb_OrderUnitType" [subid]="'cmb_OrderUnitType'"
            [(ngModel)]="model.masterInput.orderUnitType" [codeDiv]="'ct026'" [labelField]="'codeValueName'"
            [blank]="true" [tabindex]="0" [style.width.px]="250" [disabled]="hontouroku"></app-code-combo-box>
        </div>
      </div>
      <div class="column-list">
        <label class="list-input-title width-A">組数</label>
        <div class="list-input-content">
          <input type="text" id="txti_SetQuantity" [(ngModel)]="model.masterInput.setQuantity" plessInputTextSub
            [restrict]="'[0-9]'" [maxlength]="1" [tabindex]="0" [style.width.px]="30" [disabled]="hontouroku"/>
        </div>
      </div>
    </div>

    <div class="column-list">
      <label class="list-input-title" style="visibility:hidden;"></label>
      <div class="element-row price-label">
        <p>通常</p>
        <p>特１</p>
        <p>特２</p>
      </div>
      <label class="list-input-title width-B">希望価格（売価）</label>
      <div class="list-input-content">
        <input type="text" id="txti_standardSellingPrice" [(ngModel)]="model.masterInput.standardSellingPrice"
          plessInputTextSub [restrict]="'[0-9]'" [maxlength]="7" [tabindex]="0" [style.width.rem]="7" [disabled]="hontouroku"/>
        <input type="text" id="txti_special1SellingPrice" [(ngModel)]="model.masterInput.special1SellingPrice"
          plessInputTextSub [restrict]="'[0-9]'" [maxlength]="7" [tabindex]="0" [style.width.rem]="7" [disabled]="hontouroku"/>
        <input type="text" id="txti_special2SellingPrice" [(ngModel)]="model.masterInput.special2SellingPrice"
          plessInputTextSub [restrict]="'[0-9]'" [maxlength]="7" [tabindex]="0" [style.width.rem]="7" [disabled]="hontouroku"/>
      </div>
      <label class="list-input-title width-B">希望価格（仕入価）</label>
      <div class="list-input-content">
        <input type="text" id="txti_standardCostPrice" [(ngModel)]="model.masterInput.standardCostPrice"
          plessInputTextSub [restrict]="'[0-9\.]'" [maxlength]="10" [tabindex]="0" [style.width.rem]="7" [disabled]="hontouroku"/>
        <input type="text" id="txti_special1CostPrice" [(ngModel)]="model.masterInput.special1CostPrice"
          plessInputTextSub [restrict]="'[0-9\.]'" [maxlength]="10" [tabindex]="0" [style.width.rem]="7" [disabled]="hontouroku"/>
        <input type="text" id="txti_special2CostPrice" [(ngModel)]="model.masterInput.special2CostPrice"
          plessInputTextSub [restrict]="'[0-9\.]'" [maxlength]="10" [tabindex]="0" [style.width.rem]="7" [disabled]="hontouroku"/>
      </div>
      <label class="list-input-title width-B">価格バンドル</label>
      <div class="list-input-content">
        <input type="text" id="txti_BundlePrice" [(ngModel)]="model.masterInput.bundlePrice" plessInputTextSub
          [restrict]="'[0-9]'" [maxlength]="2" [tabindex]="0" [style.width.px]="40" [disabled]="hontouroku"/>
      </div>
    </div>

    <div class="block-row">
      <div class="column-list">
        <label class="list-input-title width-B">ユニットプライス区分</label>
        <div class="list-input-content">
          <app-code-combo-box id="cmb_UnitPriceDiv" [subid]="'cmb_UnitPriceDiv'"
            [(ngModel)]="model.masterInput.unitPriceDiv" [codeDiv]="'ct287'" [labelField]="'codeValueName'"
            [blank]="true" [tabindex]="0" [style.width.px]="210" [disabled]="hontouroku"></app-code-combo-box>
        </div>
        <label class="list-input-title width-B">EDLP区分</label>
        <div class="list-input-content">
          <app-code-combo-box id="cmb_EdlpDiv" [subid]="'cmb_EdlpDiv'" [(ngModel)]="model.masterInput.edlpDiv"
            [codeDiv]="'ct289'" [labelField]="'codeValueName'" [blank]="true" [tabindex]="0" [disabled]="hontouroku">
          </app-code-combo-box>
        </div>
      </div>
      <div class="column-list">
        <label class="list-input-title width-F">ユニットプライス係数</label>
        <div class="list-input-content">
          <input type="text" id="txti_UnitPriceCoefficient" [(ngModel)]="model.masterInput.unitPriceCoefficient"
            plessInputTextSub [restrict]="'[0-9\.]'" [maxlength]="8" [tabindex]="0" [style.width.rem]="8" [disabled]="hontouroku"/>
        </div>
        <label class="list-input-title width-F">消費期限</label>
        <div class="list-input-content">
          <input type="text" id="txti_expirationDate" [(ngModel)]="model.masterInput.expirationDate" plessInputTextSub
            [restrict]="'[0-9]'" [maxlength]="4" [tabindex]="0" [style.width.rem]="4" [disabled]="hontouroku"/>
        </div>
      </div>
      <div class="column-list">
        <label class="list-input-title width-B">ユニットプライス単位</label>
        <div class="list-input-content">
          <app-text-input id="txti_UnitPriceUnit" [subid]="'txti_UnitPriceUnit'"
            [(ngModel)]="model.masterInput.unitPriceUnit" plessInputTextSub [fullOnly]="true" [maxChars]="15"
            [restrict]="'[ -￮]'" [displayCountField]="false" [tabindex]="0" [style.width.rem]="17" [disabled]="hontouroku">
          </app-text-input>
        </div>
        <label class="list-input-title width-B">賞味期間</label>
        <div class="list-input-content">
          <input type="text" id="txti_bestBeforeDate" [(ngModel)]="model.masterInput.bestBeforeDate" plessInputTextSub
            [restrict]="'[0-9]'" [maxlength]="4" [tabindex]="0" [style.width.rem]="4" [disabled]="hontouroku"/>
        </div>
      </div>
    </div>


    <div class="block-row">
      <div class="column-list">
        <label class="list-input-title width-B">セット区分</label>
        <div class="list-input-content">
          <app-code-combo-box id="cmb_SetDiv" [subid]="'cmb_SetDiv'" [(ngModel)]="model.masterInput.setDiv"
            [codeDiv]="'ct144'" [labelField]="'codeValueName'" [blank]="true" [tabindex]="0"
            [style.width.px]="210" [disabled]="hontouroku"></app-code-combo-box>
        </div>
        <label class="list-input-title width-B">入荷場所区分</label>
        <div class="list-input-content">
          <app-code-combo-box id="cmb_ArrivalAreaDiv" [subid]="'cmb_ArrivalAreaDiv'"
            [(ngModel)]="model.masterInput.arrivalAreaDiv" [codeDiv]="'ct212'" [labelField]="'codeValueName'"
            [blank]="true" [tabindex]="0" [disabled]="hontouroku"></app-code-combo-box>
        </div>
        <label class="list-input-title width-B">ブランド区分</label>
        <div class="list-input-content">
          <app-code-combo-box id="cmb_BrandType" [subid]="'cmb_BrandType'" [(ngModel)]="model.masterInput.brandType"
            [codeDiv]="'ct314'" [labelField]="'codeValueName'" [blank]="true" [tabindex]="0" [disabled]="hontouroku">
          </app-code-combo-box>
        </div>
        <label class="list-input-title width-B">サイクル期間</label>
        <div class="list-input-content">
          <app-code-combo-box id="cmb_CycleTerm" [subid]="'cmb_CycleTerm'" [(ngModel)]="model.masterInput.cycleTerm"
            [codeDiv]="'ct290'" [labelField]="'codeValueName'" [blank]="true" [tabindex]="0" [disabled]="hontouroku">
          </app-code-combo-box>
        </div>
      </div>
      <div class="element-column">
        <div class="column-list">
          <label class="list-input-title width-F">ケース供給区分</label>
          <div class="list-input-content">
            <app-code-combo-box id="cmb_CaseSupplyDiv" [subid]="'cmb_CaseSupplyDiv'"
              [(ngModel)]="model.masterInput.caseSupplyDiv" [codeDiv]="'ct065'" [labelField]="'codeValueName'"
              [blank]="true" [tabindex]="0" [style.width.rem]="4" [disabled]="hontouroku"></app-code-combo-box>
          </div>
        </div>
        <div class="block-row">
          <div class="column-list">
            <label class="list-input-title width-F">入荷許可品温</label>
            <div class="list-input-content" style="width: 8rem;">
              <input type="text" id="txti_ArrivalGoodsTemp" [(ngModel)]="model.masterInput.arrivalGoodsTemp"
                plessInputTextSub [restrict]="'[\-0-9]'" [maxlength]="3" [tabindex]="0" [style.width.rem]="4" 
                [disabled]="hontouroku"/>
            </div>
          </div>
          <div class="column-list">
            <label class="list-input-title width-B">入荷管理日数</label>
            <div class="list-input-content">
              <input type="text" id="txti_ArrivalAdminDays" [(ngModel)]="model.masterInput.arrivalAdminDays"
                plessInputTextSub [restrict]="'[0-9]'" [maxlength]="3" [tabindex]="0" [style.width.rem]="3"
                [disabled]="hontouroku"/>
            </div>
          </div>
        </div>
        <div class="column-list">
          <label class="list-input-title width-F">メーカー希望小売価格（参考）</label>
          <div class="list-input-content element-row">
            <app-code-combo-box #cmb_PriceType id="cmb_PriceType" [subid]="'cmb_PriceType'"
              [(ngModel)]="model.masterInput.priceType" [codeDiv]="'ct291'" [labelField]="'codeValueName'"
              [blank]="true" [tabindex]="0" [style.width.px]="180" [disabled]="hontouroku"></app-code-combo-box>
            <input type="text" id="txti_MarkerPrice" [(ngModel)]="model.masterInput.markerPrice" plessInputTextSub
              [restrict]="'[0-9]'" [maxlength]="7" [tabindex]="0" [style.width.rem]="6" [disabled]="hontouroku"/>
          </div>
        </div>
      </div>
    </div>

    <div class="column-list">
      <label class="list-input-title width-B">環境区分</label>
      <div class="list-input-content" style="width: 500px;">
        <app-code-check-box-list #lst_EcologyDiv id="lst_EcologyDiv" [subid]="'lst_EcologyDiv'" [codeDiv]="'ct312'"
          [tabindex]="0" [disabled]="!this.isFullControl || hontouroku">
        </app-code-check-box-list>
      </div>

      <label class="list-input-title width-B">展開可能生協</label>
      <div class="list-input-content">
        <app-checkbox-label id="chk_allCoop" [subid]="'chk_AllCoop'" label="ALL" [(ngModel)]="model.masterInput.allCoop"
          (change)="eventAllCoop_CHANGEHandler()" [tabindex]="0" [disabled]="hontouroku">
        </app-checkbox-label>
        <app-checkbox-label id="chk_ibaraki" [subid]="'chk_Ibaraki'" label="い" [disabled]="hontouroku"
          [(ngModel)]="model.masterInput.expandableCoop.ibaraki" (change)="eventCoop_CHANGEHandler()" [tabindex]="0">
        </app-checkbox-label>
        <app-checkbox-label id="chk_tochigi" [subid]="'chk_Tochigi'" label="と" [disabled]="hontouroku"
          [(ngModel)]="model.masterInput.expandableCoop.tochigi" (change)="eventCoop_CHANGEHandler()" [tabindex]="0">
        </app-checkbox-label>
        <app-checkbox-label id="chk_gunma" [subid]="'chk_Gunma'" label="ぐ" [disabled]="hontouroku"
          [(ngModel)]="model.masterInput.expandableCoop.gunma" (change)="eventCoop_CHANGEHandler()" [tabindex]="0">
        </app-checkbox-label>
        <app-checkbox-label id="chk_chiba" [subid]="'chk_Chiba'" label="ち" [disabled]="hontouroku"
          [(ngModel)]="model.masterInput.expandableCoop.chiba" (change)="eventCoop_CHANGEHandler()" [tabindex]="0">
        </app-checkbox-label>
        <app-checkbox-label id="chk_saitama" [subid]="'chk_Saitama'" label="さ" [disabled]="hontouroku"
          [(ngModel)]="model.masterInput.expandableCoop.saitama" (change)="eventCoop_CHANGEHandler()" [tabindex]="0">
        </app-checkbox-label>
        <app-checkbox-label id="chk_tokyo" [subid]="'chk_Tokyo'" label="とう" [disabled]="hontouroku"
          [(ngModel)]="model.masterInput.expandableCoop.tokyo" (change)="eventCoop_CHANGEHandler()" [tabindex]="0">
        </app-checkbox-label>
        <app-checkbox-label id="chk_nagano" [subid]="'chk_Nagano'" label="な" [disabled]="hontouroku"
          [(ngModel)]="model.masterInput.expandableCoop.nagano" (change)="eventCoop_CHANGEHandler()" [tabindex]="0">
        </app-checkbox-label>
        <app-checkbox-label id="chk_niigata" [subid]="'chk_Niigata'" label="に" [disabled]="hontouroku"
          [(ngModel)]="model.masterInput.expandableCoop.niigata" (change)="eventCoop_CHANGEHandler()" [tabindex]="0">
        </app-checkbox-label>
      </div>
    </div>

    <div class="column-list">
      <label class="list-input-title" style="visibility:hidden;"></label>
      <div class="list-input-content photo-label">
        <p>撮影枚数</p>
        <p>データ枚数</p>
      </div>
      <label class="list-input-title width-E">A.包材</label>
      <div class="list-input-content photo-label">
        <input type="text" id="txti_PackagePhotoNum" [(ngModel)]="model.masterInput.packagePhotoNum" plessInputTextSub
          [restrict]="'[0-9]'" [maxlength]="1" [tabindex]="0"
          [disabled]="hontouroku"/>
        <input type="text" id="txti_PackageDataNum" [(ngModel)]="model.masterInput.packageDataNum" plessInputTextSub
          [restrict]="'[0-9]'" [maxlength]="1" [tabindex]="0"
          [disabled]="hontouroku"/>
      </div>
      <label class="list-input-title width-E">B.盛り</label>
      <div class="list-input-content photo-label">
        <input type="text" id="txti_PeakPhotoNum" [(ngModel)]="model.masterInput.peakPhotoNum" plessInputTextSub
          [restrict]="'[0-9]'" [maxlength]="1" [tabindex]="0"
          [disabled]="hontouroku"/>
        <input type="text" id="txti_PeakDataNum" [(ngModel)]="model.masterInput.peakDataNum" plessInputTextSub
          [restrict]="'[0-9]'" [maxlength]="1" [tabindex]="0"
          [disabled]="hontouroku"/>
      </div>
      <label class="list-input-title width-E">C.調理イメージ（調理要）</label>
      <div class="list-input-content photo-label">
        <input type="text" id="txti_CookingNecessaryPhotoNum" [(ngModel)]="model.masterInput.cookingNecessaryPhotoNum"
          plessInputTextSub [restrict]="'[0-9]'" [maxlength]="1" [tabindex]="0"
          [disabled]="hontouroku"/>
        <input type="text" id="txti_CookingNecessaryDataNum" [(ngModel)]="model.masterInput.cookingNecessaryDataNum"
          plessInputTextSub [restrict]="'[0-9]'" [maxlength]="1" [tabindex]="0"
          [disabled]="hontouroku"/>
      </div>
      <label class="list-input-title width-E">C.調理イメージ（調理不要）</label>
      <div class="list-input-content photo-label">
        <input type="text" id="txti_CookingUnnecessaryPhotoNum"
          [(ngModel)]="model.masterInput.cookingUnnecessaryPhotoNum" plessInputTextSub [restrict]="'[0-9]'"
          [maxlength]="1" [tabindex]="0"
          [disabled]="hontouroku"/>
        <input type="text" id="txti_CookingUnnecessaryDataNum"
          [(ngModel)]="model.masterInput.cookingUnnecessaryDataNum" plessInputTextSub [restrict]="'[0-9]'"
          [maxlength]="1" [tabindex]="0"
          [disabled]="hontouroku"/>
      </div>
      <label class="list-input-title width-E">D.説明・素材</label>
      <div class="list-input-content photo-label">
        <input type="text" id="txti_MaterialPhotoNum" [(ngModel)]="model.masterInput.materialPhotoNum"
          plessInputTextSub [restrict]="'[0-9]'" [maxlength]="1" [tabindex]="0"
          [disabled]="hontouroku"/>
        <input type="text" id="txti_MaterialDataNum" [(ngModel)]="model.masterInput.materialDataNum" plessInputTextSub
          [restrict]="'[0-9]'" [maxlength]="1" [tabindex]="0"
          [disabled]="hontouroku"/>
      </div>
      <label class="list-input-title width-E">F.裏面</label>
      <div class="list-input-content photo-label">
        <input type="text" id="txti_BacksidePhotoNum" [(ngModel)]="model.masterInput.backsidePhotoNum"
          plessInputTextSub [restrict]="'[0-9]'" [maxlength]="1" [tabindex]="0"
          [disabled]="hontouroku"/>
        <input type="text" id="txti_BacksideDataNum" [(ngModel)]="model.masterInput.backsideDataNum" plessInputTextSub
          [restrict]="'[0-9]'" [maxlength]="1" [tabindex]="0"
          [disabled]="hontouroku"/>
      </div>
    </div>

    <div class="block-row">
      <div class="column-list">
        <label class="list-input-title width-E">商品説明</label>
        <div class="list-input-content">
          <app-text-area id="txb_GoodsExplanation" [subid]="'txb_GoodsExplanation'"
            [(ngModel)]="model.masterInput.goodsExplanation" plessInputTextSub [restrict]="'[ -￮]'"
            [displayCountField]="true" [maxChars]="200" [fullOnly]="true" [counterWidth]="'60px'"
            [tabindex]="0" [style.width.px]="600" (blur)="eventTextInfo1_FOCUS_OUTHandler()"
            [disabled]="hontouroku">
          </app-text-area>
        </div>
        <label class="list-input-title width-E">おすすめコメント</label>
        <div class="list-input-content">
          <app-text-area id="txb_RecommendComment" [subid]="'txb_RecommendComment'"
            [(ngModel)]="model.masterInput.recommendComment" plessInputTextSub [restrict]="'[ -￮]'"
            [displayCountField]="true" [maxChars]="200" [fullOnly]="true" [counterWidth]="'60px'"
            [tabindex]="0" [style.width.px]="600" (blur)="eventTextInfo3_FOCUS_OUTHandler()"
            [disabled]="hontouroku">
          </app-text-area>
        </div>
        <label class="list-input-title width-E">便利情報（商品構成内容）</label>
        <div class="list-input-content">
          <app-text-area id="txb_UsefulInfoConfiguration" [subid]="'txb_UsefulInfoConfiguration'"
            [(ngModel)]="model.masterInput.usefulInfoConfiguration" plessInputTextSub [restrict]="'[ -￮]'"
            [displayCountField]="true" [maxChars]="200" [fullOnly]="true" [counterWidth]="'60px'"
            [tabindex]="0" [style.width.px]="600" (blur)="eventTextInfo5_FOCUS_OUTHandler()"
            [disabled]="hontouroku">
          </app-text-area>
        </div>
        <label class="list-input-title width-E">便利情報（サイズ他）</label>
        <div class="list-input-content">
          <app-text-area id="txb_UsefulInfoSize" [subid]="'txb_UsefulInfoSize'"
            [(ngModel)]="model.masterInput.usefulInfoSize" plessInputTextSub [restrict]="'[ -￮]'"
            [displayCountField]="true" [maxChars]="200" [fullOnly]="true" [counterWidth]="'60px'"
            [tabindex]="0" [style.width.px]="600" (blur)="eventTextInfo7_FOCUS_OUTHandler()"
            [disabled]="hontouroku">
          </app-text-area>
        </div>
      </div>
      <div class="column-list">
        <label class="list-input-title width-E">キャッチコピー</label>
        <div class="list-input-content">
          <app-text-area id="txb_CatchPhrase" [subid]="'txb_CatchPhrase'" [(ngModel)]="model.masterInput.catchPhrase"
            plessInputTextSub [restrict]="'[ -￮]'" [displayCountField]="true" [maxChars]="200" [fullOnly]="true"
            [counterWidth]="'60px'" [tabindex]="0" [style.width.px]="600" (blur)="eventTextInfo2_FOCUS_OUTHandler()"
            [disabled]="hontouroku">
          </app-text-area>
        </div>
        <label class="list-input-title width-E">便利情報（囲み）</label>
        <div class="list-input-content">
          <app-text-area id="txb_UsefulInfoEnclosure" [subid]="'txb_UsefulInfoEnclosure'"
            [(ngModel)]="model.masterInput.usefulInfoEnclosure" plessInputTextSub [restrict]="'[ -￮]'"
            [displayCountField]="true" [maxChars]="200" [fullOnly]="true" [counterWidth]="'60px'"
            [tabindex]="0" [style.width.px]="600" (blur)="eventTextInfo4_FOCUS_OUTHandler()"
            [disabled]="hontouroku">
          </app-text-area>
        </div>
        <label class="list-input-title width-E">便利情報（その他）</label>
        <div class="list-input-content">
          <app-text-area id="txb_UsefulInfoOther" [subid]="'txb_UsefulInfoOther'"
            [(ngModel)]="model.masterInput.usefulInfoOther" plessInputTextSub [restrict]="'[ -￮]'"
            [displayCountField]="true" [maxChars]="200" [fullOnly]="true" [counterWidth]="'60px'"
            [tabindex]="0" [style.width.px]="600" (blur)="eventTextInfo6_FOCUS_OUTHandler()"
            [disabled]="hontouroku">
          </app-text-area>
        </div>
        <label class="list-input-title width-E">取扱注意</label>
        <div class="list-input-content">
          <app-text-area id="txb_HandlingCaution" [subid]="'txb_HandlingCaution'"
            [(ngModel)]="model.masterInput.handlingCaution" plessInputTextSub [restrict]="'[ -￮]'"
            [displayCountField]="true" [maxChars]="200" [fullOnly]="true" [counterWidth]="'60px'"
            [tabindex]="0" [style.width.px]="600" (blur)="eventTextInfo8_FOCUS_OUTHandler()"
            [disabled]="hontouroku">
          </app-text-area>
        </div>
      </div>
    </div>

    <div class="column-list">
      <label class="list-input-title width-E">マーク</label>
      <div class="element-column">
        <div class="list-input-content_two-row">
          <app-reserve-code-combo-box #cmb_MarkDiv1 id="cmb_MarkDiv1" [subid]="'cmb_MarkDiv1'"
            [(ngModel)]="model.masterInput.markDiv.markDiv1" [codeDiv]="model.markDivCtp"
            [conReserve1]="model.getMarkReserve()" [labelField]="'codeValueName'" [blank]="true" [tabindex]="0"
            [initAutoLoad]="false" class="cmb-mark" [disabled]="hontouroku"></app-reserve-code-combo-box>
          <app-reserve-code-combo-box #cmb_MarkDiv2 id="cmb_MarkDiv2" [subid]="'cmb_MarkDiv2'"
            [(ngModel)]="model.masterInput.markDiv.markDiv2" [codeDiv]="model.markDivCtp"
            [conReserve1]="model.getMarkReserve()" [labelField]="'codeValueName'" [blank]="true" [tabindex]="0"
            [initAutoLoad]="false" class="cmb-mark" [disabled]="hontouroku"></app-reserve-code-combo-box>
          <app-reserve-code-combo-box #cmb_MarkDiv3 id="cmb_MarkDiv3" [subid]="'cmb_MarkDiv3'"
            [(ngModel)]="model.masterInput.markDiv.markDiv3" [codeDiv]="model.markDivCtp"
            [conReserve1]="model.getMarkReserve()" [labelField]="'codeValueName'" [blank]="true" [tabindex]="0"
            [initAutoLoad]="false" class="cmb-mark" [disabled]="hontouroku"></app-reserve-code-combo-box>
          <app-reserve-code-combo-box #cmb_MarkDiv4 id="cmb_MarkDiv4" [subid]="'cmb_MarkDiv4'"
            [(ngModel)]="model.masterInput.markDiv.markDiv4" [codeDiv]="model.markDivCtp"
            [conReserve1]="model.getMarkReserve()" [labelField]="'codeValueName'" [blank]="true" [tabindex]="0"
            [initAutoLoad]="false" class="cmb-mark" [disabled]="hontouroku"></app-reserve-code-combo-box>
          <app-reserve-code-combo-box #cmb_MarkDiv5 id="cmb_MarkDiv5" [subid]="'cmb_MarkDiv5'"
            [(ngModel)]="model.masterInput.markDiv.markDiv5" [codeDiv]="model.markDivCtp"
            [conReserve1]="model.getMarkReserve()" [labelField]="'codeValueName'" [blank]="true" [tabindex]="0"
            [initAutoLoad]="false" class="cmb-mark" [disabled]="hontouroku"></app-reserve-code-combo-box>
        </div>

        <div class="list-input-content_two-row">
          <app-reserve-code-combo-box #cmb_MarkDiv6 id="cmb_MarkDiv6" [subid]="'cmb_MarkDiv6'"
            [(ngModel)]="model.masterInput.markDiv.markDiv6" [codeDiv]="model.markDivCtp"
            [conReserve1]="model.getMarkReserve()" [labelField]="'codeValueName'" [blank]="true" [tabindex]="0"
            [initAutoLoad]="false" class="cmb-mark" [disabled]="hontouroku"></app-reserve-code-combo-box>
          <app-reserve-code-combo-box #cmb_MarkDiv7 id="cmb_MarkDiv7" [subid]="'cmb_MarkDiv7'"
            [(ngModel)]="model.masterInput.markDiv.markDiv7" [codeDiv]="model.markDivCtp"
            [conReserve1]="model.getMarkReserve()" [labelField]="'codeValueName'" [blank]="true" [tabindex]="0"
            [initAutoLoad]="false" class="cmb-mark" [disabled]="hontouroku"></app-reserve-code-combo-box>
          <app-reserve-code-combo-box #cmb_MarkDiv8 id="cmb_MarkDiv8" [subid]="'cmb_MarkDiv8'"
            [(ngModel)]="model.masterInput.markDiv.markDiv8" [codeDiv]="model.markDivCtp"
            [conReserve1]="model.getMarkReserve()" [labelField]="'codeValueName'" [blank]="true" [tabindex]="0"
            [initAutoLoad]="false" class="cmb-mark" [disabled]="hontouroku"></app-reserve-code-combo-box>
          <app-reserve-code-combo-box #cmb_MarkDiv9 id="cmb_MarkDiv9" [subid]="'cmb_MarkDiv9'"
            [(ngModel)]="model.masterInput.markDiv.markDiv9" [codeDiv]="model.markDivCtp"
            [conReserve1]="model.getMarkReserve()" [labelField]="'codeValueName'" [blank]="true" [tabindex]="0"
            [initAutoLoad]="false" class="cmb-mark" [disabled]="hontouroku"></app-reserve-code-combo-box>
          <app-reserve-code-combo-box #cmb_MarkDiv10 id="cmb_MarkDiv10" [subid]="'cmb_MarkDiv10'"
            [(ngModel)]="model.masterInput.markDiv.markDiv10" [codeDiv]="model.markDivCtp"
            [conReserve1]="model.getMarkReserve()" [labelField]="'codeValueName'" [blank]="true" [tabindex]="0"
            [initAutoLoad]="false" class="cmb-mark" [disabled]="hontouroku"></app-reserve-code-combo-box>
        </div>
      </div>
    </div>
  </div>

  <wj-tab-panel id="tab_KYMW6901MasterInputTab" #tab_KYMW6901MasterInputTab [(selectedIndex)]="model.selectedTabIndex"
    [tabindex]="-1">
    <wj-tab>
      <a>食品</a>
      <div class="contents-area">
        <div class="element-column">
          <div class="column-list">
            <label class="list-input-title width-A">消費税</label>
            <div class="list-input-content">
              <input type="text" id="txti_consumeTaxRate" [(ngModel)]="model.masterInput.consumeTaxRate"
                plessInputTextSub [restrict]="'[0-9]'" [maxlength]="2" [tabindex]="0" [style.width.rem]="3"
                [disabled]="hontouroku"/>
            </div>
          </div>
          <div class="block-row">
            <div class="column-list">
              <label class="list-input-title width-A">アルコール度数</label>
              <div class="list-input-content">
                <app-text-input id="txti_alcoholPercentage" [subid]="'txti_AlcoholPercentage'"
                  [(ngModel)]="model.masterInput.alcoholPercentage" [fullOnly]="true" [maxChars]="20"
                  [restrict]="'[ -￮]'" [displayCountField]="false" [tabindex]="0" [style.width.rem]="22"
                  [disabled]="hontouroku">
                </app-text-input>
              </div>
              <label class="list-input-title width-A">日本酒度</label>
              <div class="list-input-content">
                <app-text-input id="txti_sakeMeterValue" [subid]="'txti_SakeMeterValue'"
                  [(ngModel)]="model.masterInput.sakeMeterValue" [fullOnly]="true" [maxChars]="20" [restrict]="'[ -￮]'"
                  [displayCountField]="false" [tabindex]="0" [style.width.rem]="22"
                  [disabled]="hontouroku">
                </app-text-input>
              </div>
              <label class="list-input-title width-A">機能性・特保</label>
              <div class="list-input-content">
                <app-code-combo-box id="cmb_functionalOrFoshu" [subid]="'cmb_functionalOrFoshu'"
                  [(ngModel)]="model.masterInput.functionalOrFoshu" [codeDiv]="'ctp269'" [labelField]="'codeValueName'"
                  [blank]="true" [tabindex]="0" [style.width.rem]="22"
                  [disabled]="hontouroku"></app-code-combo-box>
              </div>
            </div>
            <div class="column-list">
              <label class="list-input-title width-A">果汁</label>
              <div class="list-input-content">
                <app-text-input id="txti_fruitJuice" [subid]="'txti_FruitJuice'"
                  [(ngModel)]="model.masterInput.fruitJuice" [fullOnly]="true" [maxChars]="20" [restrict]="'[ -￮]'"
                  [displayCountField]="false" [tabindex]="0" [style.width.rem]="22"
                  [disabled]="hontouroku">
                </app-text-input>
              </div>
              <label class="list-input-title width-A">ボディ</label>
              <div class="list-input-content">
                <app-text-input id="txti_body" [subid]="'txti_Body'" [(ngModel)]="model.masterInput.body"
                  plessInputTextSub [fullOnly]="true" [maxChars]="20" [restrict]="'[ -￮]'" [displayCountField]="false"
                  [tabindex]="0" [style.width.rem]="22" [disabled]="hontouroku">
                </app-text-input>
              </div>
            </div>
          </div>
          <div class="block-row">
            <div class="column-list">
              <label class="list-input-title width-A">酒類コード</label>
              <div class="list-input-content">
                <app-code-combo-box id="cmb_LiquorCode" [subid]="'cmb_LiquorCode'"
                  [(ngModel)]="model.masterInput.liquorCode" [codeDiv]="'ct362'" [labelField]="'codeValueName'"
                  [blank]="true" [tabindex]="0" [style.width.rem]="22" 
                  [disabled]="hontouroku"></app-code-combo-box>
              </div>
            </div>
            <div class="column-list">
              <label class="list-input-title width-A">アルコール分別</label>
              <div class="list-input-content">
                <input type="text" id="txti_AlcoholType" [(ngModel)]="model.masterInput.alcoholType" plessInputTextSub
                  [restrict]="'[0-9\.]'" [maxlength]="6" [tabindex]="0" [style.width.rem]="8" 
                  [disabled]="hontouroku"/>
              </div>
            </div>
            <div class="column-list">
              <label class="list-input-title width-A">容器形態</label>
              <div class="list-input-content">
                <app-code-combo-box id="cmb_ContainerForm" [subid]="'cmb_ContainerForm'"
                  [(ngModel)]="model.masterInput.containerForm" [codeDiv]="'ct360'" [labelField]="'codeValueName'"
                  [blank]="true" [tabindex]="0" [style.width.px]="250" 
                  [disabled]="hontouroku"></app-code-combo-box>
              </div>
            </div>
          </div>
        </div>
      </div>
    </wj-tab>
    <wj-tab>
      <a>住関連</a>
      <div class="contents-area">
        <div class="element-column">
          <div class="column-list">
            <label class="list-input-title width-D">取扱期間</label>
            <div class="list-input-content">
              <wj-input-date style="width:136px;" id="dtf_ApplyTermStart" #dtf_ApplyTermStart
                [tabindex]="0" [isRequired]="false" [(text)]="model.masterInput.applyTermStart" format="yyyy/MM/dd"
                [isDisabled]="hontouroku">
              </wj-input-date>
              <span>～</span>
              <wj-input-date style="width:136px;" id="dtf_ApplyTermEnd" #dtf_ApplyTermEnd
                [tabindex]="0" [isRequired]="false" [(text)]="model.masterInput.applyTermEnd" format="yyyy/MM/dd"
                [isDisabled]="hontouroku">
              </wj-input-date>
              <button id="btn_ApplyTermClear" class="btn-tartiary" (click)="eventApplyTermClearHandler()"
                forcedEnabledMode="true" [tabindex]="0" style="width: 60px;" [hidden]="hontouroku">クリア</button>
            </div>
            <label class="list-input-title width-D">季節消費期限</label>
            <div class="list-input-content">
              <input type="checkbox" id="chk_SeasonConsumeDiv" [(ngModel)]="model.masterInput.seasonConsumeDiv"
                [tabindex]="0" [disabled]="hontouroku"/>
              <wj-input-date style="width:105px;" id="dtf_SeasonConsumeTermStart" #dtf_SeasonConsumeTermStart
                [tabindex]="0" [isRequired]="false" [(text)]="model.masterInput.seasonConsumeTermStart" format="MM/dd"
                [isDisabled]="hontouroku">
              </wj-input-date>
              <span>～</span>
              <wj-input-date style="width:105px;" id="dtf_SeasonConsumeTermEnd" #dtf_SeasonConsumeTermEnd
                [tabindex]="0" [isRequired]="false" [(text)]="model.masterInput.seasonConsumeTermEnd" format="MM/dd"
                [isDisabled]="hontouroku">
              </wj-input-date>
              <button id="btn_SeasonConsumeTermClear" class="btn-tartiary" (click)="eventSeasonConsumeTermClearHandler()"
                forcedEnabledMode="true" [tabindex]="0" style="width: 60px;" [hidden]="hontouroku">クリア</button>
            </div>
            <label class="list-input-title width-D">臭い商品区分</label>
            <div class="list-input-content">
              <app-code-combo-box id="cmb_StinkGoodsDiv" [subid]="'cmb_StinkGoodsDiv'"
                [(ngModel)]="model.masterInput.stinkGoodsDiv" [codeDiv]="'ct110'" [labelField]="'codeValueName'"
                [blank]="true" [tabindex]="0" [style.width.px]="134" [disabled]="hontouroku"></app-code-combo-box>
            </div>
            <label class="list-input-title width-D">表組用商品名</label>
            <div class="list-input-content">
              <app-text-input id="txti_listingGoodsName" [subid]="'txti_ListingGoodsName'"
                [(ngModel)]="model.masterInput.listingGoodsName" [fullOnly]="true" [maxChars]="30" [restrict]="'[ -￮]'"
                [displayCountField]="false" [tabindex]="0" [style.width.rem]="32" [disabled]="hontouroku">
              </app-text-input>
            </div>
          </div>
          <div class="block-row">
            <div class="column-list">
              <label class="list-input-title width-D">種類</label>
              <div class="list-input-content">
                <app-text-input id="txti_ListingType" [subid]="'txti_ListingType'"
                  [(ngModel)]="model.masterInput.listingType" [fullOnly]="true" [maxChars]="25" [restrict]="'[ -￮]'"
                  [displayCountField]="false" [tabindex]="0" [style.width.rem]="27" [disabled]="hontouroku">
                </app-text-input>
              </div>
              <label class="list-input-title width-D">サイズ（ｃｍ）</label>
              <div class="list-input-content">
                <app-text-input id="txti_ListingSizeCm" [subid]="'txti_ListingSizeCm'"
                  [(ngModel)]="model.masterInput.listingSizeCm" [fullOnly]="true" [maxChars]="25" [restrict]="'[ -￮]'"
                  [displayCountField]="false" [tabindex]="0" [style.width.rem]="27" [disabled]="hontouroku">
                </app-text-input>
              </div>
              <label class="list-input-title width-D">ピースサイズ（縦）</label>
              <div class="list-input-content">
                <input type="text" id="txti_PieceSizeLength" [(ngModel)]="model.masterInput.pieceSizeLength"
                  plessInputTextSub [restrict]="'[0-9]'" [maxlength]="4" [tabindex]="0" [style.width.rem]="5" 
                  [disabled]="hontouroku"/>
              </div>
              <label class="list-input-title width-D">ピースサイズ（横）</label>
              <div class="list-input-content">
                <input type="text" id="txti_PieceSizeWidth" [(ngModel)]="model.masterInput.pieceSizeWidth"
                  plessInputTextSub [restrict]="'[0-9]'" [maxlength]="4" [tabindex]="0" [style.width.rem]="5" 
                  [disabled]="hontouroku"/>
              </div>
              <label class="list-input-title width-D">ピースサイズ（高）</label>
              <div class="list-input-content">
                <input type="text" id="txti_PieceSizeHeight" [(ngModel)]="model.masterInput.pieceSizeHeight"
                  plessInputTextSub [restrict]="'[0-9]'" [maxlength]="4" [tabindex]="0" [style.width.rem]="5" 
                  [disabled]="hontouroku"/>
              </div>
              <label class="list-input-title width-D">ピースサイズ（重量）</label>
              <div class="list-input-content">
                <input type="text" id="txti_PieceWeight" [(ngModel)]="model.masterInput.pieceWeight" plessInputTextSub
                  [restrict]="'[0-9]'" [maxlength]="5" [tabindex]="0" [style.width.rem]="5" 
                  [disabled]="hontouroku"/>
              </div>
            </div>
            <div class="column-list">
              <label class="list-input-title">内容量</label>
              <div class="list-input-content">
                <app-text-input id="txti_ListingContentsQuantity" [subid]="'txti_ListingContentsQuantity'"
                  [(ngModel)]="model.masterInput.listingContentsQuantity" [fullOnly]="true" [maxChars]="25"
                  [restrict]="'[ -￮]'" [displayCountField]="false" [tabindex]="0" [style.width.rem]="27"
                  [disabled]="hontouroku">
                </app-text-input>
              </div>
              <label class="list-input-title">枚数</label>
              <div class="list-input-content">
                <app-text-input id="txti_ListingNumber" [subid]="'txti_ListingNumber'"
                  [(ngModel)]="model.masterInput.listingNumber" [fullOnly]="true" [maxChars]="25" [restrict]="'[ -￮]'"
                  [displayCountField]="false" [tabindex]="0" [style.width.rem]="27"
                  [disabled]="hontouroku">
                </app-text-input>
              </div>
              <label class="list-input-title">ケースサイズ（縦）</label>
              <div class="list-input-content">
                <input type="text" id="txti_CaseSizeLength" [(ngModel)]="model.masterInput.caseSizeLength"
                  plessInputTextSub [restrict]="'[0-9]'" [maxlength]="4" [tabindex]="0" [style.width.rem]="5" 
                  [disabled]="hontouroku"/>
              </div>
              <label class="list-input-title">ケースサイズ（横）</label>
              <div class="list-input-content">
                <input type="text" id="txti_CaseSizeWidth" [(ngModel)]="model.masterInput.caseSizeWidth"
                  plessInputTextSub [restrict]="'[0-9]'" [maxlength]="4" [tabindex]="0" [style.width.rem]="5" 
                  [disabled]="hontouroku"/>
              </div>
              <label class="list-input-title">ケースサイズ（高）</label>
              <div class="list-input-content">
                <input type="text" id="txti_CaseSizeHeight" [(ngModel)]="model.masterInput.caseSizeHeight"
                  plessInputTextSub [restrict]="'[0-9]'" [maxlength]="4" [tabindex]="0" [style.width.rem]="5" 
                  [disabled]="hontouroku"/>
              </div>
              <label class="list-input-title">ケースサイズ（重量）</label>
              <div class="list-input-content">
                <input type="text" id="txti_CaseWeight" [(ngModel)]="model.masterInput.caseWeight" plessInputTextSub
                  [restrict]="'[0-9]'" [maxlength]="5" [tabindex]="0" [style.width.rem]="5" 
                  [disabled]="hontouroku"/>
              </div>
            </div>
            <div class="column-list">
              <label class="list-input-title" style="width: 5rem;">サイズ</label>
              <div class="list-input-content">
                <app-text-input id="txti_ListingSize" [subid]="'txti_ListingSize'"
                  [(ngModel)]="model.masterInput.listingSize" [fullOnly]="true" [maxChars]="25" [restrict]="'[ -￮]'"
                  [displayCountField]="false" [tabindex]="0" [style.width.rem]="27"
                  [disabled]="hontouroku">
                </app-text-input>
              </div>
              <label class="list-input-title">色</label>
              <div class="list-input-content">
                <app-text-input id="txti_ListingColor" [subid]="'txti_ListingColor'"
                  [(ngModel)]="model.masterInput.listingColor" [fullOnly]="true" [maxChars]="25" [restrict]="'[ -￮]'"
                  [displayCountField]="false" [tabindex]="0" [style.width.rem]="27"
                  [disabled]="hontouroku">
                </app-text-input>
              </div>
            </div>
          </div>
          <div class="column-list">
            <label class="list-input-title width-D">成分情報（化粧品）</label>
            <div class="list-input-content">
              <app-text-area id="txb_IngredientInfo" [subid]="'txb_IngredientInfo'"
                [(ngModel)]="model.masterInput.ingredientInfo" plessInputTextSub [restrict]="'[ -￮]'"
                [displayCountField]="true" [maxChars]="2000" [fullOnly]="true" [counterWidth]="'75px'"
                [tabindex]="0" (blur)="eventTextInfo9_FOCUS_OUTHandler()" [disabled]="hontouroku">
              </app-text-area>
            </div>
            <label class="list-input-title width-D">原材料表示（ペットのみ）</label>
            <div class="list-input-content">
              <app-text-area id="txb_IngredientDisp" [subid]="'txb_IngredientDisp'"
                [(ngModel)]="model.masterInput.ingredientDisp" plessInputTextSub [restrict]="'[ -￮]'"
                [displayCountField]="true" [maxChars]="2000" [fullOnly]="true" [counterWidth]="'75px'"
                [tabindex]="0" (blur)="eventTextInfoA_FOCUS_OUTHandler()" [disabled]="hontouroku">
              </app-text-area>
            </div>
          </div>
        </div>
      </div>
    </wj-tab>
  </wj-tab-panel>
  <div>
    <wj-accordion #wad_goodsdept [isAnimated]="false" [allowCollapseAll]="true" [allowExpandMany]="true"
      (initialized)="initCollapsed(wad_goodsdept, model.isClient())">
      <wj-accordion-pane>
        <div>商品部記入表</div>
        <div>
          <div class="element-column">
            <div class="column-list">
              <label class="list-input-title width-C">関連Ｐコード（旧）</label>
              <div class="list-input-content">
                <input type="text" #txti_RelationPCodeOld id="txti_RelationPCodeOld" [(ngModel)]="model.masterInput.relationPCodeOld"
                  [restrict]="'[P0-9]'" [maxlength]="8" class="pcode" plessInputTextSub [disabled]="hontouroku"/>
              </div>
            </div>
            <div class="block-row">
              <div class="column-list">
                <label class="list-input-title width-C">特殊発注区分</label>
                <div class="list-input-content">
                  <app-code-combo-box #cmb_SpecialOrderType id="cmb_SpecialOrderType" [subid]="'cmb_SpecialOrderType'"
                    [(ngModel)]="model.masterInput.specialOrderType" [codeDiv]="'ct216'" [labelField]="'codeValueName'"
                    [blank]="true" [tabindex]="0" [style.width.rem]="7"
                    [disabled]="hontouroku"></app-code-combo-box>
                </div>
              </div>
              <div class="column-list">
                <label class="list-input-title width-C">在庫繰越区分</label>
                <div class="list-input-content">
                  <app-code-combo-box #cmb_StockType id="cmb_StockType" [subid]="'cmb_StockType'"
                    [(ngModel)]="model.masterInput.stockType" [codeDiv]="'ct115'" [labelField]="'codeValueName'"
                    [blank]="true" [tabindex]="0" [style.width.rem]="8"
                    [disabled]="hontouroku"></app-code-combo-box>
                </div>
              </div>
              <div class="column-list">
                <label class="list-input-title width-C">物流滞留日数</label>
                <div class="list-input-content">
                  <input #txti_PdPilingUpDays type="text" id="txti_PdPilingUpDays"
                    [(ngModel)]="model.masterInput.pdPilingUpDays" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="3"
                    [tabindex]="0" [style.width.rem]="3" [disabled]="hontouroku"/>
                </div>
              </div>
            </div>
            <div class="column-list">
              <label class="list-input-title width-C">製造地</label>
              <div class="list-input-content">
                <input type="text" #txti_FactoryAddress1 id="txti_FactoryAddress1" [(ngModel)]="model.masterInput.factoryAddress1"
                  plessInputTextSub [restrict]="'[ -￮]'" [maxlength]="50" [tabindex]="0" [style.width.rem]="52"
                  [disabled]="hontouroku" [fullOnly]="true"/>
              </div>
              <label class="list-input-title width-C">製造地２</label>
              <div class="list-input-content">
                <input type="text" #txti_FactoryAddress2 id="txti_FactoryAddress2" [(ngModel)]="model.masterInput.factoryAddress2"
                  plessInputTextSub [restrict]="'[ -￮]'" [maxlength]="50" [tabindex]="0" [style.width.rem]="52"
                  [disabled]="hontouroku" [fullOnly]="true"/>
              </div>
              <label class="list-input-title width-C">FC/MC手数料</label>
              <div class="list-input-content">
                <input type="text" #txti_FcmcFee id="txti_FcmcFee" [(ngModel)]="model.masterInput.fcmcFee"
                  plessInputTextSub [restrict]="'[0-9\.]'" [maxlength]="9" [tabindex]="0" [style.width.rem]="8" 
                  [disabled]="hontouroku"/>
              </div>
            </div>
          </div>
        </div>
      </wj-accordion-pane>
    </wj-accordion>
  </div>
  <ng-container *ngIf="!this.isBeforeProposing() && !hontouroku">
    <div class="layout_end">
      <button id="btn_Register" class="btn-primary" (click)="eventRegist_CLICKHandler()">登録</button>
    </div>
  </ng-container>
</div>